/**
 * Tour steps — Detection domain
 * Cubre: correlation-rules, sigma-rules, yara-rules, mini-siem
 */

import {
  GitBranch,
  Detective,
  Bug,
  Database
} from '@phosphor-icons/react';

// ============ CORRELATION RULES (solo full) ============
const correlationRulesProspect = {
  id: 'correlation-rules',
  title: 'Detecta patrones sospechosos',
  description: 'En lugar de ver eventos sueltos, Vektor conecta los puntos y te avisa cuando algo encaja con un patrón conocido de ataque. Menos ruido, más señal.',
  icon: GitBranch,
  position: 'right',
  highlight: '[data-testid="nav-correlation"]',
  fallbackSelector: '[href="/correlation"]',
  mode: 'prospect',
  length: 'full',
  domain: 'detection',
  videoFallback: null
};

const correlationRulesOnboarding = {
  id: 'correlation-rules',
  title: 'Correlation Engine per-tenant',
  description: 'Motor de correlación aislado por tenant con routing kind=sigma → sigma_engine en Layer 2 y bridge Layer3 → alert engine. Soporta condiciones temporales y agregaciones.',
  icon: GitBranch,
  position: 'right',
  highlight: '[data-testid="nav-correlation"]',
  fallbackSelector: '[href="/correlation"]',
  mode: 'onboarding',
  length: 'full',
  domain: 'detection',
  videoFallback: null
};

// ============ SIGMA RULES (solo full) ============
const sigmaRulesProspect = {
  id: 'sigma-rules',
  title: 'Más de 3.000 reglas de detección incluidas',
  description: 'No partes de cero. Vektor trae miles de reglas creadas por la comunidad para detectar técnicas de atacantes conocidos. Importa, activa y listo.',
  icon: Detective,
  position: 'right',
  highlight: '[data-testid="nav-sigma-rules"]',
  fallbackSelector: '[href="/sigma-rules"]',
  mode: 'prospect',
  length: 'full',
  domain: 'detection',
  videoFallback: null
};

const sigmaRulesOnboarding = {
  id: 'sigma-rules',
  title: 'Sigma Rules — 3132 reglas SigmaHQ',
  description: 'Catálogo completo de SigmaHQ importado en correlation_rules. UI dentro de /correlation para activar por familia (process_creation, network_connection, etc). Detection-as-Code real.',
  icon: Detective,
  position: 'right',
  highlight: '[data-testid="nav-sigma-rules"]',
  fallbackSelector: '[href="/sigma-rules"]',
  mode: 'onboarding',
  length: 'full',
  domain: 'detection',
  videoFallback: null
};

// ============ YARA RULES (solo full) ============
const yaraRulesProspect = {
  id: 'yara-rules',
  title: 'Identifica archivos maliciosos',
  description: 'Reglas que reconocen huellas de malware conocido en ficheros. Si entra algo sospechoso por correo o descarga, lo detectas al instante.',
  icon: Bug,
  position: 'right',
  highlight: '[data-testid="nav-yara-rules"]',
  fallbackSelector: '[href="/yara-rules"]',
  mode: 'prospect',
  length: 'full',
  domain: 'detection',
  videoFallback: null
};

const yaraRulesOnboarding = {
  id: 'yara-rules',
  title: 'YARA Rules',
  description: 'Reglas YARA para identificación de malware por patrones binarios/strings. Útil para hunting sobre artefactos extraídos por el agente (procesos, ficheros droppeados, payloads).',
  icon: Bug,
  position: 'right',
  highlight: '[data-testid="nav-yara-rules"]',
  fallbackSelector: '[href="/yara-rules"]',
  mode: 'onboarding',
  length: 'full',
  domain: 'detection',
  videoFallback: null
};

// ============ MINI SIEM (solo full) ============
const miniSiemProspect = {
  id: 'mini-siem',
  title: 'Buscador de eventos integrado',
  description: 'Busca cualquier evento de cualquier equipo desde una sola pantalla. Sin necesidad de pagar un SIEM aparte para investigaciones rápidas.',
  icon: Database,
  position: 'right',
  highlight: '[data-testid="nav-mini-siem"]',
  fallbackSelector: '[href="/mini-siem"]',
  mode: 'prospect',
  length: 'full',
  domain: 'detection',
  videoFallback: null
};

const miniSiemOnboarding = {
  id: 'mini-siem',
  title: 'Mini-SIEM integrado',
  description: 'Búsqueda y filtrado sobre el log store del tenant. Ideal para triaging de alertas, hunting ad-hoc y validación de detecciones nuevas sin saltar a Splunk/Sentinel.',
  icon: Database,
  position: 'right',
  highlight: '[data-testid="nav-mini-siem"]',
  fallbackSelector: '[href="/mini-siem"]',
  mode: 'onboarding',
  length: 'full',
  domain: 'detection',
  videoFallback: null
};

export const domainSteps = {
  prospect: {
    quick: [],
    full: [correlationRulesProspect, sigmaRulesProspect, yaraRulesProspect, miniSiemProspect]
  },
  onboarding: {
    quick: [],
    full: [correlationRulesOnboarding, sigmaRulesOnboarding, yaraRulesOnboarding, miniSiemOnboarding]
  }
};
